import { useState } from "react";
import { PopupPagoFinal } from "../../../popup";
import { Elements } from "@stripe/react-stripe-js";
import { stripePromise } from "../../../utils/stripePromise"; // ✅ usa la promesa centralizada
import Pago from "../pagos/Pago";
import { InputCss, OcultarDatosCss } from "../../../styles";
import TotalPago from "../pagos/TotalPago";
import { calcularTotalConIVA } from "../../../utils/calcularTotalIva";
import { ButtonSiguiente } from "../../../ui";
import { Datos4Props, PaymentOption } from "@/types";
/* import { ContratoPdfRef } from "../contratoServicios/ContratoServicios"; */

const Datos4: React.FC<Datos4Props> = ({
  isFirmaAccepted,
  selectedProfesiones = [],
  paymentAmount,
  setTotalPago,
  contratoRef,
  firmaBase64,
  formData1,
  formData2,
  paymentOption,
  isEmpresa,
  modoRenovar = false,
  /* onGuardarDatosUsuario, */
}) => {
  const [paymentPopupVisible, setPaymentPopupVisible] = useState(false);
  const [descuento, setDescuento] = useState<number>(0);
  const iva: number = 0;
  const [, setIsPagoRealizado] = useState(false);
  const [codigoPromocional, setCodigoPromocional] = useState<string | null>(null);
  const [, setMensajeCodigo] = useState<string | null>(null);
  const profesionalId = formData1?.usuario_id;
  const perfilProfesionalId = selectedProfesiones[0];


  // Helper type-guard para validar PaymentOption en runtime
  const isPaymentOption = (v: any): v is PaymentOption =>
    v === "Mensual" || v === "Semestral" || v === "Anual";

  // Validamos y normalizamos la prop antes de pasar a Pago
  const validatedPaymentOption: PaymentOption | undefined = isPaymentOption(paymentOption)
    ? paymentOption
    : undefined;

  const calculateTotal = () => {
    return selectedProfesiones.length * (paymentAmount ?? 0);
  };

  const precioOriginal = calculateTotal();
  // Solo aplicamos descuento si la opción de pago es Anual
  const precioConDescuento =
    validatedPaymentOption === "Anual" ? precioOriginal * (1 - descuento / 100) : precioOriginal;

  const totalConIVA = calcularTotalConIVA(precioConDescuento, iva);

  const upateTotalPago = (newTotal: number) => {
    setTotalPago?.(newTotal);
  };

  const handlePayClick = () => {
    if (!isFirmaAccepted) return; // 🔒 previene ejecución sin firma
    upateTotalPago(totalConIVA);
    setPaymentPopupVisible(true);
  };

  const handlePagoExitoso = () => {
    setIsPagoRealizado(true);
    /* if (onGuardarDatosUsuario) onGuardarDatosUsuario(); */
  };



  return (
    <div
      className={`datos4 ${!isFirmaAccepted ? `${OcultarDatosCss.niebla}` : ""
        } xs:col-span-12 sm:col-span-12 md:col-span-4 px-3 py-1 space-y-1 rounded-md border dark:bg-white dark:text-zinc-700 ${InputCss.inputEdita}`}
    >
      <div className="flex items-center gap-2 col-span-2">
        <h3 className="font-semibold underline">Pago:</h3>
      </div>


      <TotalPago
        precioOriginal={precioOriginal}
        onTotalPagarChange={setTotalPago}
        onDescuentoChange={setDescuento}
        setCodigoPromocional={setCodigoPromocional}
        onMensajeChange={setMensajeCodigo}
        descuentoHabilitado={validatedPaymentOption === "Anual"}
        profesionalId={profesionalId}
        perfilProfesionalId={perfilProfesionalId}
      />

      <div className="flex justify-center pb-2">
        <ButtonSiguiente onClick={handlePayClick} className="w-full">
          {modoRenovar ? "Renovar suscripción" : "Pagar"}
        </ButtonSiguiente>
      </div>

      {paymentPopupVisible && (
        <PopupPagoFinal
          isOpen={paymentPopupVisible}
          onClose={() => setPaymentPopupVisible(false)}
          className="max-w-80 justify-center"
        >
          <Elements stripe={stripePromise}>
            <Pago
              totalPago={totalConIVA}
              setTotalPago={setTotalPago}
              onTotalPagarChange={setTotalPago}
              onClosePopup={() => setPaymentPopupVisible(false)}
              contratoRef={contratoRef}
              firmaBase64={firmaBase64}
              selectedProfesiones={selectedProfesiones}
              onPagoExitoso={handlePagoExitoso}
              formData1={formData1!}
              formData2={formData2}
              /* <-- PASAMOS el valor ya validado y tipado */
              paymentOption={validatedPaymentOption}
              isEmpresa={isEmpresa}
              precioOriginal={precioOriginal}
              descuento={descuento}
              /*  onGuardarDatosUsuario={onGuardarDatosUsuario} */
              idUsuario={formData1?.usuario_id}
              modoRenovar={modoRenovar}
              codigoPromocional={codigoPromocional}
              profesionalId={profesionalId}
              perfilProfesionalId={perfilProfesionalId}
            />
          </Elements>
        </PopupPagoFinal>
      )}
    </div>
  );
};

export default Datos4;

